import { useQuery } from '@tanstack/react-query';
import { ICountry } from '../../Interfaces/ICountry';
import { customFetcher } from '../useFetch';

export const useGetCountries = () => {
  const { data: countries, isLoading: isLoadingCountries } = useQuery<
    ICountry[]
  >({
    queryKey: ['country'],
    queryFn: () => customFetcher({ endpoint: '/country' }),
  });

  return { countries, isLoadingCountries };
};
